import { AnswerFileResult } from "../../../store/viewmodels/AnswerFileViewModel";
import { getFileElement } from "../../../utils/TaskContentServices";

interface StudentVideoModalProps {
    answer?: AnswerFileResult,
    close: () => void,
}

function StudentVideoModal(props: StudentVideoModalProps): JSX.Element {

    if (props.answer === undefined) {
        return <div>Ei näytettävää</div>;
    }

    let videoElement = getFileElement(props.answer);

    return (
        <div className="m-10">
            <div className="">
                {videoElement}
            </div>
            <div className="w-1/3 my-4 float-right">
                <button onClick={props.close} type="button"
                    className="block w-full text-sm font-medium rounded-md border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                    Sulje
                </button>
            </div>
        </div>
    );
}

export default StudentVideoModal;